export default "__VITE_ASSET__DiGBp4ZE__"